import { DataDefinition } from "@soft-db/data-formatter";
import { Base64Query } from "@soft-db/monitoring-api-client";
import { fromBase64, toBase64 } from "@soft-db/soft-utils";

export function useBase64Query(version = 2) {
	return {
		serialize(definition: DataDefinition): Base64Query {
			return {
				version,
				query: toBase64(JSON.stringify(definition)),
			};
		},
		deserialize(query: Base64Query): DataDefinition {
			if (!query.query) return {} as DataDefinition;

			return JSON.parse(fromBase64(query.query)) as DataDefinition;
		},
	};
}
